import Vue from 'vue'
import config from './config.js'
import Utils from './utils.js'


const AccountService = {

  create: (account) => {
    let create_request = () => {
      // console.log('creating account: ' + JSON.stringify(account, undefined, 2))
      return Vue.http.post(config.apiUrl() + '/services/accounts/create', account)
    }
    return Utils.generic_request(create_request)
  },

  patch: (id, changeSet) => {
    let patch_request = () => {
      // console.log('updating account: ' + JSON.stringify(changeSet, undefined, 2))
      return Vue.http.patch(config.apiUrl() + '/accounts/' + id, changeSet)
    }
    return Utils.generic_request(patch_request)
  },

  findById: (id)  =>  {
    let find_by_id_request = () => {
      return Vue.http.get(config.apiUrl() + '/accounts/' + id)
    }
    return Utils.generic_request(find_by_id_request)
  },

  isEmpty: (value)  =>  {
    return  (value == '' || value == undefined )
  },
  
  verifyUsername: (username) => {
    let verify_username_request = () => {
      return Vue.http.get(config.apiUrl() + '/services/users/check_username?username=' + escape(username))
    }
    return Utils.generic_request(verify_username_request)
  },

find: (searchCriteria) => {
  let find_request = () => {
    // console.log('searching account: ' + JSON.stringify(searchCriteria, undefined, 2))
    let url = config.apiUrl() + '/accounts?'      
    let keys = Object.keys(searchCriteria)
    keys.forEach((key) => {url += `${key}=${searchCriteria[key]}&`})
    console.log('find Account: ' + url)
    return Vue.http.get(url)
  }
  return Utils.generic_request(find_request)
},

}
export default AccountService



// WEBPACK FOOTER //
// ./src/accountService.js